import React from "react";
import { withRouter, useHistory } from "react-router-dom";
import { Image, Row, Typography } from "antd";
import { useUser } from "providers/user";
import {
  // AreaChartOutlined,
  HomeOutlined,
  CarOutlined,
  UserSwitchOutlined,
} from "@ant-design/icons";
import { Link, useLocation } from "react-router-dom";

import Logo from "./logo.png";

const { Text } = Typography;

const Sidebar = () => {
  const location = useLocation();
  const { user } = useUser();
  const { push } = useHistory();

  return (
    <div
      style={{
        width: 240,
        background: "white",
        height: "100vh",
        flexShrink: 0,
      }}
    >
      <Row
        style={{ justifyContent: "center", cursor: "pointer" }}
        onClick={() => push("/dashboard")}
      >
        <Image
          style={{
            display: "block",
            paddingLeft: 40,
            marginTop: 30,
            paddingRight: 40,
          }}
          height={21}
          preview={false}
          src={Logo}
          alt=""
        />
      </Row>
      <Row style={{ justifyContent: "center" }}>
        <div
          style={{
            marginTop: 70,
            borderRadius: 20,
            overflow: "hidden",
          }}
        >
          <Image
            style={{
              display: "block",
              borderRadius: 50,
            }}
            height={80}
            src={"https://cdn-icons-png.flaticon.com/512/147/147144.png"}
            alt=""
          />
        </div>
      </Row>
      <div style={{ alignItems: "center", textAlign: "center", marginTop: 5 }}>
        <Text style={{ fontWeight: "800", fontSize: 15 }}>
          {user?.client?.name}
        </Text>
        <br />
        <Text style={{ color: "#8c8c8c" }}> {user?.email}</Text>
        <br />
        <br />
      </div>
      <div
        style={{
          display: "flex",
          marginTop: 40,
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div
          style={{
            background: location.pathname === "/pickPack" ? "#52B266" : "none",
            padding: 5,
            borderRadius: 20,
            marginRight: 5,
            marginLeft: 5,
          }}
        >
          <Link to={"/tracking"} style={{ marginLeft: 10, cursor: "pointer" }}>
            <Row
              style={{
                alignItems: "center",
              }}
            >
              <HomeOutlined
                style={{
                  fontSize: 18,
                }}
              />
              <Text
                style={{
                  fontSize: 17,
                  marginLeft: 10,
                  fontWeight: location.pathname === "/tracking" ? "900" : "500",
                }}
              >
                Rastreo
              </Text>
            </Row>
          </Link>
          <Link to={"/services"} style={{ marginLeft: 10, cursor: "pointer" }}>
            <Row
              style={{
                alignItems: "center",
              }}
            >
              <CarOutlined
                style={{
                  fontSize: 18,
                }}
              />
              <Text
                style={{
                  fontSize: 17,
                  marginLeft: 10,
                  color:
                    location.pathname === "/services" ? "black" : "#8c8c8c",
                  fontWeight: "900",
                }}
              >
                Unidades
              </Text>
            </Row>
          </Link>

          <Link to={"/profile"} style={{ marginLeft: 10, cursor: "pointer" }}>
            <Row
              style={{
                alignItems: "center",
              }}
            >
              <UserSwitchOutlined
                style={{
                  fontSize: 18,
                }}
              />
              <Text
                style={{
                  fontSize: 17,
                  marginLeft: 10,
                  color: location.pathname === "/profile" ? "black" : "#8c8c8c",
                  fontWeight: "900",
                }}
              >
                Mi Perfil
              </Text>
            </Row>
          </Link>
          {/* 
          <Link
            to={"/performance"}
            style={{ marginLeft: 10, cursor: "pointer" }}
          >
            <Row
              style={{
                alignItems: "center",
              }}
            >
              <AreaChartOutlined
                style={{
                  fontSize: 18,
                }}
              />
              <Text
                style={{
                  fontSize: 17,
                  marginLeft: 10,
                  color:
                    location.pathname === "/performance" ? "black" : "#8c8c8c",
                  fontWeight: "900",
                }}
              >
                Rendimiento
              </Text>
            </Row>
          </Link> */}
        </div>
      </div>
    </div>
  );
};

export default withRouter(Sidebar);
